import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

function Protected(props) {
    const Cmp = props.cmp;
    var userData = localStorage.getItem('userData');
    return <div>{userData ? <Cmp /> : <Redirect to='login'></Redirect>}</div>
}

export default Protected;